import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { EnumAPIStatus } from '@api/AbstractAPI';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumDocumentType } from '@models/Common';
import { IConsumersWalletModel } from '@models/Consumers';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { CompressUtils } from '@utils/CompressUtils';
import { FileUtils } from '@utils/FileUtils';
import { FormValidators } from '@validators/form.validators';

@Component({
    selector: 'app-claim-award',
    templateUrl: './claim-award.component.html',
    styleUrls: ['./claim-award.component.scss'],
})
export class ClaimAwardModalComponent implements OnInit {


    public Form: FormGroup;

    private onGetUser: Function;
    private onGetAvailableCards: Function;

    private data: IConsumersWalletModel;

    public AvailableCards: any[] = [];


    public MaxValidityDate: string = "";
    public MinValidityDate: string = "";

    private showAlert: Function;
    private showToast: Function;
    private onSave: Function;

    public ConsumerDocumentType = EnumDocumentType;

    private maxFileSizeKB: number = 3072;
    private ticket: { Id: string, Code: string };

    constructor(private ModalController: ModalController,
        private NavParams: NavParams) {


        this.ticket = this.NavParams.get('ticket') || null
        this.onGetUser = this.NavParams.get("onGetUser") || new Function;
        this.onGetAvailableCards = this.NavParams.get("onGetAvailableCards") || new Function;

        this.showAlert = this.NavParams.get("showAlert") || new Function;
        this.showToast = this.NavParams.get("showToast") || new Function;
        this.showToast = this.NavParams.get("showToast") || new Function;
        this.onSave = this.NavParams.get("onSave") || new Function;


        const currentDate = new Date();

        currentDate.setFullYear(currentDate.getFullYear() + 100);

        this.MaxValidityDate = currentDate.toISOString();

        this.MinValidityDate = new Date().toISOString();

        this.createFormElements();

    }

    async ngOnInit() {


        this.data = await this.onGetUser();

        this.AvailableCards = await this.onGetAvailableCards();

        this.createFormElements();
        console.log(this.AvailableCards);

    }

    /**
     * 
     * @param data 
     */
    private createFormElements(verificationTypeWithEmail = true, data: IConsumersWalletModel = this.data) {


        console.log(verificationTypeWithEmail);


        const addressproof = data?.UserFilesList?.find(it => it?.IdAttachmentType == 111),
            identityProof = data?.UserFilesList?.find(it => it?.IdAttachmentType == 114);

        this.Form = new FormGroup({
            IdUser: new FormControl(data?.IdUser || null),
            IdWallet: new FormControl(data?.IdWallet || null),
            WalletSynchronized: new FormControl(data?.WalletSynchronized || null),
            Email: new FormControl({ value: data?.Contact?.Email || null, disabled: data?.Contact?.Email ? true : false }, [FormValidators.EmailValidator, Validators.required]),
            MobilePhone: new FormControl(data?.Contact?.MobilePhone || null, [FormValidators.TelephoneValidator, Validators.required]),
            Name: new FormControl(data?.Name || null, [Validators.required]),
            BirthDate: new FormControl(data?.BirthDate || '', [Validators.required]),
            IdentificationDocumentValidityDate: new FormControl({ value: data?.IdentificationDocumentValidityDate || '', disabled: data?.IdentificationDocumentValidityDate ? true : false }, [Validators.required]),
            IdDocumentType: new FormControl({ value: data?.IdDocumentType || '', disabled: data?.IdentificationDocumentNumber ? true : false }),
            IdentificationDocumentNumber: new FormControl({ value: data?.IdentificationDocumentNumber || '', disabled: data?.IdentificationDocumentNumber ? true : false }, [Validators.required]),
            VatNumber: new FormControl({ value: (data?.VatNumber || ''), disabled: data?.VatNumber ? true : false }, [Validators.required, FormValidators.NIFValidator]),
            Username: new FormControl(data?.Username || ''),
            Observations: new FormControl(''),
            tempObservations: new FormControl(''),

            WalletCard: new FormControl(null, []),

            PhysicalCardRequired: new FormControl({ value: data?.WalletCard?.PhysicalCardRequired ?? false, disabled: true }, []),
            ClaimCardId: new FormControl(null, [Validators.required]),
            ClaimTicketCode: new FormControl({ value: this.ticket.Code, disabled: true }, [Validators.required]),
            ClaimTicketId: new FormControl({ value: this.ticket.Id, disabled: true }, [Validators.required]),
            Location: new FormGroup({
                Id: new FormControl(data?.Location?.Id || null),
                Locality: new FormControl(data?.Location?.Locality || '', [Validators.required]),
                ZipCode: new FormControl(data?.Location?.ZipCode || '', [Validators.required, FormValidators.ZipCodeValidator]),
                Address: new FormControl(data?.Location?.Address || '', [Validators.required]),
                // District: new FormControl(data?.Location?.District || '', [Validators.required]),
                // County: new FormControl(data?.Location?.County || '', [Validators.required]),
            }),
            // ModuleList: new FormControl(data?.ModuleList || [], verificationTypeWithEmail ? [Validators.required] : []),
            // Image: new FormGroup({
            //     Id: new FormControl(data?.Image?.Id || null, []),
            //     Path: new FormControl(data?.Image?.Path || null, []),
            //     OriginalName: new FormControl(data?.Image?.OriginalName || null, [])
            // }),
            AddressProof: new FormControl(addressproof || null, ((!data?.IdUser && verificationTypeWithEmail) || addressproof) ? [Validators.required] : []),
            IdentityProof: new FormControl(identityProof || null, ((!data?.IdUser && verificationTypeWithEmail) || identityProof) ? [Validators.required] : []),
            IdWalletBalanceStatus300: new FormControl(data?.WalletCard?.IdWalletBalanceStatus300 || null),

        });




    }
    /**
    * 
    * @param file 
    * @param control 
    * @returns 
    */
    async OnChangeFile(file, control: FormControl | any, documentType = EnumDocumentType.ProofOfAddress) {

        console.log(file);

        control.markAsTouched();
        control.markAsDirty();

        control.setValue(null);

        if (!file || file?.files?.length == 0) {
            this.showToast("Escolha o ficheiro");
            return;
        }

        const mimeType = file?.files[0]?.type;

        let fileUpdated: File[] = file?.files;

        let fileBase64: any = null;

        if (mimeType === 'application/pdf') {
            // PDF - sem compressão
            console.log('Ficheiro PDF selecionado:', fileUpdated);
            // this.handleFinalFile(file);
            // return;

            try {

                fileBase64 = await FileUtils.GetBase64(fileUpdated[0]);

            } catch (error) {

            }

        }
        else if (mimeType?.startsWith('image/')) {
            try {
                const compressed: any = await CompressUtils.CompressImageFile(fileUpdated[0]);

                console.log(compressed);

                fileUpdated = [compressed];

                fileBase64 = await FileUtils.GetBase64(compressed);

                // this.handleFinalFile(compressed);
            } catch (error) {
                console.error('Erro ao comprimir imagem:', error);

            }
        }
        else {

            try {
                fileBase64 = await FileUtils.GetBase64(fileUpdated[0]);

            } catch (error) {

            }
        }

        if (!FileUtils.VerifyFileExtension(fileUpdated, ['.pdf', '.jpg', '.jpeg', '.png', '.heic', '.webp', '.avif', '.heif'])) {
            return this.showAlert('Aviso', 'Ficheiro não é válido, selecione um dos seguintes formatos suportados (.pdf, .jpg, .jpeg, .png)', [{
                text: 'confirmar',
                role: EnumGenericRoleActionAlerts.Confirm
            }]);
        }
        else if (!FileUtils.VerifyFileSizeKB(fileUpdated, this.maxFileSizeKB)) {
            return this.showAlert('Aviso', `Ficheiro ultrapassa o limite de ${this.maxFileSizeKB / 1024}Mb.`, [{
                text: 'confirmar',
                role: EnumGenericRoleActionAlerts.Confirm
            }]);
        }


        control.setErrors(null);

        const formFile: any =
        {
            Id: 0,
            OriginalName: file.files[0].name,
            Base64Data: FileUtils.RemoveMimeTypeBase64(fileBase64),
            Type: '',
            Path: '',
            IdAttachmentType: documentType,
            File: file.files[0]
        }

        control.setValue(formFile);

        control.markAsDirty();

        control.updateValueAndValidity();

        console.log(formFile);

    }

    /**
     * 
     * @param ev 
     */
    public OnChangeTextQuill(ev: any) {

        this.Form.get('tempObservations').setValue(ev);

        if (ev) {
            if (JSON.stringify(this.Form.get('tempObservations').value) != JSON.stringify(this.Form.get('Observations').value))
                this.Form.get('tempObservations').markAsDirty();

        }

    }

    /**
     * 
     * @param control 
     * @returns 
     */
    public IsFormControlRequired(control: AbstractControl | null): boolean {

        if (!control) return false;

        return (control.hasValidator(Validators.required) || control.hasValidator(FormValidators.RequiredValidator))
    }

    public async OnSave(ev?: any) {


        if (!this.Form.dirty) return await this.showToast('Não foram encontradas alterações.');

        this.Form.markAllAsTouched();

        console.log(this.Form);


        if (!this.Form.valid) {


            return await this.showToast('Preencha todos os campos assinalados.');
        }


        const { role } = await this.showAlert();

        if (role != EnumGenericRoleActionAlerts.Confirm) return;

        const submit = {

            Ticket: {
                Id: this.Form.get('ClaimTicketId').value
            },
            Card: {
                Id: this.Form.get('ClaimCardId').value
            },
            UserData: {
                IdUser: this.Form.get('IdUser').value,
                Name: this.Form.get('Name').value || '',
                VatNumber: this.Form.get('VatNumber').value || '',
                // ExternalUser_Id: this.Form.get('ExternalUser_Id').value||'',
                Contact:
                {
                    Email: this.Form.get('Email').value || '',
                    MobilePhone: this.Form.get('MobilePhone').value || '',
                },
                IdentificationDocumentNumber: this.Form.get('IdentificationDocumentNumber').value || '',
                IdDocumentType: this.Form.get('IdDocumentType').value || '',
                BirthDate: this.Form.get('BirthDate').value || '',
                IdentificationDocumentValidityDate: this.Form.get('IdentificationDocumentValidityDate').value || '',
                Username: this.Form.get('Username').value || '',
                Location:
                {
                    Id: this.Form.get('Location').get('Id').value || null,
                    ZipCode: this.Form.get('Location').get('ZipCode').value || '',
                    Locality: this.Form.get('Location').get('Locality').value || '',
                    Address: this.Form.get('Location').get('Address').value || '',
                },
                // PhysicalCardRequired: this.Form.get('PhysicalCardRequired').value,
                // IdWalletBalanceStatus300: this.Form.get('IdWalletBalanceStatus300').value || null,
                // ModuleList: (this.Form.get('ModuleList')?.value || [])?.map(it => Number(it.Id))
                // ImageCard: this.Form.get('Image')?.get('Id').value ? null :
                //     {
                //         Id: null,
                //         OriginalName: this.Form.get('Image')?.get('OriginalName').value || "",
                //         Path: null,
                //         Base64Data: FileUtils.RemoveMimeTypeBase64(this.Form.get('Image')?.get('Path').value) || '',
                //         Type: "image/jpg"
                //     }
            },
            Observations: this.Form.get('tempObservations').value || '',
        }

        console.log(submit);

        const formdata = new FormData();

        formdata.append("data", JSON.stringify(submit));

        //falta ficheiros [REVER]
        // formdata.append("file1", file1);
        // formdata.append("file2", file2);

        const r: any = await this.onSave(formdata);

        console.log(r);

        this.showToast(r?.Error?.Message);

        if (r.Status != EnumAPIStatus.Success) return;

        this.ModalController.dismiss();


    }


    Close(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }
}
